window.personalised = window.personalised || {};
window.personalised.validation = window.personalised.validation || {
  validateBundleLoaded: () => false,
  bundleHasItems: () => false,
  isValidFrequency: () => false,
  isValidFrequencyMultiplier: () => false
};

// CUSTOM: personalised-validation.js
// Safe validation functions for personalised bundle state

/**
 * Validates that the bundle is properly loaded
 * @returns {boolean} True if bundle exists and is initialized (even if empty)
 */
function validateBundleLoaded() {
  try {
    // Check if bundle module and its methods are available
    const bundleInitialized = window.personalised?.bundle?.getItems instanceof Function;
    
    // Only verify items is an array, don't check for items.length > 0
    const items = bundleInitialized ? window.personalised.bundle.getItems() : null;
    
    // Bundle is loaded if it's initialized AND items is a valid array (even if empty)
    return bundleInitialized && Array.isArray(items);
  } catch (err) {
    return false;
  }
}

/**
 * Validates that the bundle frequency is a positive number or a string that parses to a positive number
 * @returns {boolean} True if frequency is valid
 */
function isValidFrequency() {
  try {
    const freq = window.personalised?.bundle?.getFrequency?.();
    if (!freq) return false;
    
    // Handle both string and number types
    if (typeof freq === 'number') {
      return freq > 0;
    } else if (typeof freq === 'string') {
      const parsedFreq = parseInt(freq, 10);
      return !isNaN(parsedFreq) && parsedFreq > 0;
    }
    return false;
  } catch (err) {
    return false;
  }
}

/**
 * Validates that the bundle has at least one item
 * @returns {boolean} True if bundle has items
 */
function bundleHasItems() {
  try {
    const count = window.personalised?.bundle?.getItemCount?.();
    return typeof count === 'number' && count > 0;
  } catch (err) {
    return false;
  }
}

/**
 * Validates that a frequency multiplier value is valid (positive number)
 * @param {*} value - The value to validate
 * @returns {boolean} True if value is a positive number
 */
function isValidFrequencyMultiplier(value) {
  return typeof value === 'number' && value > 0;
}

// Export validation functions
window.personalised = window.personalised || {};
window.personalised.validation = {
  validateBundleLoaded,
  isValidFrequency,
  bundleHasItems,
  isValidFrequencyMultiplier
};
